import { render, staticRenderFns } from "./ChatSingleProcess.vue?vue&type=template&id=774c9f2a&"
import script from "./ChatSingleProcess.vue?vue&type=script&lang=js&"
export * from "./ChatSingleProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports